import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { CREATE_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { promptField } from '../schema-prompts/prompt-field.js'
import { promptSelectValue } from '../schema-prompts/prompt-select-value.js'
import { createFieldPromptOptions } from './create-field-prompt-options.js'

export async function promptSchemaSlotField(
  kind: 'entity' | 'single',
  schemasDir: string,
  mainFields: SchemaField[],
  sidebarFields: SchemaField[]
): Promise<void> {
  const slot = await promptSelectValue(
    CREATE_PROMPT_CONTEXT,
    'Field slot',
    [
      { value: 'main', label: 'main' },
      { value: 'sidebar', label: 'sidebar' }
    ],
    'main'
  )
  const field = (await promptField(
    CREATE_PROMPT_CONTEXT,
    kind,
    schemasDir,
    'schema',
    0,
    createFieldPromptOptions([...mainFields, ...sidebarFields])
  )) as SchemaField
  if (slot === 'sidebar') {
    sidebarFields.push(field)
  } else {
    mainFields.push(field)
  }
}
